export default __webpack_public_path__ + "static/media/icon-googlepodcasts.8c3ccf11.svg";